'use strict'
import tokens from './service/tokens.js'

let instaled = false

let cooperadoWebAPI = {}
cooperadoWebAPI.tokens = tokens

// plugin install
const install = Vue => {
  if (instaled) {
    return // users plugin já foi instalado
  }

  Object.defineProperties(Vue.prototype, {
    $cooperadowebapi: {
      get () {
        return cooperadoWebAPI
      }
    }
  })

  instaled = true
}

export default { install }


// WEBPACK FOOTER //
// ./src/pluginCooperadoWebAPI.js